import { useContext, useState, useEffect } from 'react';
import { Container, IconButton } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from '../../../stores/ThemeContext';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useGeneralInfoStore } from '../../../stores/GeneralInfoStore';
import { TileData, useTranslatedTilesData } from '../../../config/tilesConfig';
import appConfig from '../../../config/appConfig';
import { StyledHeader, MyToolbar } from './styles';
import NavigationDrawer from './NavigationDrawer';

import OrganizationLogo from '../../componets/header/OrganizationLogo';

const MobileHeader = () => {
    const navigate = useNavigate();
    const { darkMode, toggleDarkMode } = useContext(ThemeContext);
    const theme = useTheme();
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const translatedTiles = useTranslatedTilesData();
    const [routesConfig, setRoutesConfig] = useState<{ [key: string]: boolean }>({});
    const { t } = useTranslation();
    const {
        category,
        setCategory,
        setCurrentPage,
        setIsCookieBannerVisible,
        isCookieBannerVisible
    } = useGeneralInfoStore();

    const checkedColor = theme.palette.switch.checked;
    const trackColor = theme.palette.switch.track;
    const iconColor = theme.palette.switch.icon;
    const logoColor = theme.palette.customText.logo;

    useEffect(() => {
        setRoutesConfig(appConfig.Pages);
    }, []);

    const handleDrawerToggle = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };

    const handleTileSelect = (tile: TileData) => {
        if (tile.linkTo) {
            window.open(tile.linkTo, '_blank', 'noopener,noreferrer');
        } else {
            setCurrentPage(tile.titleKey);
            navigate(tile.navigateTo);
        }
        handleDrawerToggle();
    };

    return (
        <StyledHeader>
            <Container sx={{ paddingLeft: "1rem !important", paddingRight: "0.5rem !important" }}>
                <MyToolbar>
                    <div onClick={() => { navigate("/"); }}>
                        <OrganizationLogo />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <IconButton
                            color="inherit"
                            aria-label={t('mobileHeader.menu.open')}
                            onClick={handleDrawerToggle}
                            sx={{
                                color: logoColor,
                                padding: '8px',
                                '&:hover': {
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)'
                                }
                            }}
                        >
                            <MenuIcon />
                        </IconButton>
                    </div>
                </MyToolbar>
            </Container>
            <NavigationDrawer
                isOpen={isDrawerOpen}
                onClose={handleDrawerToggle}
                darkMode={darkMode}
                toggleDarkMode={toggleDarkMode}
                routesConfig={routesConfig}
                translatedTiles={translatedTiles}
                onTileSelect={handleTileSelect}
                checkedColor={checkedColor}
                trackColor={trackColor}
                iconColor={iconColor}
                logoColor={logoColor}
                isCookieBannerVisible={isCookieBannerVisible}
                setIsCookieBannerVisible={setIsCookieBannerVisible}
            />
        </StyledHeader>
    );
};

export default MobileHeader;